<button (click)="makeCopy()" mat-icon-button
        matTooltip="Kopiera, klistra in i Excel">
  <mat-icon class="positive">grid_on</mat-icon>
</button>
